module.exports = __webpack_public_path__ + "./Frank_5f6d464992d76327d3dfadea9c8790b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Frank.jpg
// module id = 552
// module chunks = 0